export default "__VITE_ASSET__Cz0TJ_bV__"